import FaqComponent from "../../FaqComponent/FaqComponent";
import TutorialBlock from "../../remove_video_bg/UploadFileLanding/TutorialBlock/TutorialBlock";
import TryOurTools from "../../tryOurTools/tryOurTools";
import MainBlock from "./MainBlock/MainBlock";
import RightBlock from "./RightBlock/RightBlock";
import UseCases from "./UseCases/UseCases";

function ServiceLayout({ dictionary, startService }) {
	const mainBlockData = {
		title: "page_illustration_h1",
		description: "page_illustration_descriptor",
		mainPicture: "/illustration_service/main_block.jpg",
	};
	const rightBlockData = {
		title: "page_illustartion_h2",
		description: "page_illustration_descriptor2",
		imageSrc: "/illustration_service/second_block.jpg",
	};
	const textData = {
		title: dictionary["page_illustration_h4"],
		youtubeUrl: "https://www.youtube-nocookie.com/embed/H9s2Ilucmq4?fs=0&modestbranding=1&iv_load_policy=3",
		posterUrl: "/illustration_service/tutorial_block.jpg",
	};
	const tutorialData = [
		{
			title: dictionary["page_illustration_block4_h1"] || "Choose background",
			description: dictionary["page_illustration_block4_d1"] || "Choose thematic background for your future illustration",
		},
		{
			title: dictionary["page_illustration_block4_h2"] || "Add character / object",
			description: dictionary["page_illustration_block4_d2"] || "Describe characters/objects that you would like to see on your illustration",
		},
		{
			title: dictionary["page_illustration_block4_h3"] || "Adjust noise level",
			description: dictionary["page_illustration_block4_d3"] || "Move the slider to make your illustration more realistic and complex",
		},
	];

	return (
		<>
			<MainBlock dictionary={dictionary} mainBlockData={mainBlockData} startService={startService} />
			<RightBlock dictionary={dictionary} blockData={rightBlockData} />
			<UseCases dictionary={dictionary} />
			<TutorialBlock tutorialData={tutorialData} textData={textData} hasBlobs={true} />
			<FaqComponent dictionary={dictionary} pageName={"page_illustration"} isPurpleBack={true} />
			<TryOurTools t={dictionary} />
		</>
	);
}

export default ServiceLayout;
